/* tslint:disable */
import {
  Institutions,
  ReportsMedia,
  ReportComment
} from '../index';

declare var Object: any;
export interface ReportInterface {
  "title": string;
  "description": string;
  "sf_issue_id"?: string;
  "sf_casework_id"?: string;
  "sf_client_id"?: string;
  "age_group"?: string;
  "gender"?: string;
  "constituency_name"?: string;
  "other_constituency_name"?: string;
  "county_name"?: string;
  "other_county_name"?: string;
  "institution_id"?: number;
  "institution_name"?: string;
  "sector_name"?: string;
  "sector_id"?: string;
  "status": string;
  "unique_data_id"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institution?: Institutions;
  reportsMedia?: ReportsMedia[];
  comments?: ReportComment[];
}

export class Report implements ReportInterface {
  "title": string;
  "description": string;
  "sf_issue_id": string;
  "sf_casework_id": string;
  "sf_client_id": string;
  "age_group": string;
  "gender": string;
  "constituency_name": string;
  "other_constituency_name": string;
  "county_name": string;
  "other_county_name": string;
  "institution_id": number;
  "institution_name": string;
  "sector_name": string;
  "sector_id": string;
  "status": string;
  "unique_data_id": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institution: Institutions;
  reportsMedia: ReportsMedia[];
  comments: ReportComment[];
  constructor(data?: ReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Report`.
   */
  public static getModelName() {
    return "Report";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Report for dynamic purposes.
  **/
  public static factory(data: ReportInterface): Report{
    return new Report(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Report',
      plural: 'Reports',
      path: 'Reports',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "sf_issue_id": {
          name: 'sf_issue_id',
          type: 'string'
        },
        "sf_casework_id": {
          name: 'sf_casework_id',
          type: 'string'
        },
        "sf_client_id": {
          name: 'sf_client_id',
          type: 'string'
        },
        "age_group": {
          name: 'age_group',
          type: 'string'
        },
        "gender": {
          name: 'gender',
          type: 'string'
        },
        "constituency_name": {
          name: 'constituency_name',
          type: 'string'
        },
        "other_constituency_name": {
          name: 'other_constituency_name',
          type: 'string'
        },
        "county_name": {
          name: 'county_name',
          type: 'string'
        },
        "other_county_name": {
          name: 'other_county_name',
          type: 'string'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "institution_name": {
          name: 'institution_name',
          type: 'string'
        },
        "sector_name": {
          name: 'sector_name',
          type: 'string'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'APPROVED'
        },
        "unique_data_id": {
          name: 'unique_data_id',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institution: {
          name: 'institution',
          type: 'Institutions',
          model: 'Institutions'
        },
        reportsMedia: {
          name: 'reportsMedia',
          type: 'ReportsMedia[]',
          model: 'ReportsMedia'
        },
        comments: {
          name: 'comments',
          type: 'ReportComment[]',
          model: 'ReportComment'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Report.ts